/* Host injection seam for the enterprise-local Translation bundle.
 *
 * ``gtcAgentSlot`` 과 같은 패턴이다. 번역 페이지는 enterprise 앱에 있고
 * (백엔드 번역 API 호출이 host 의존), 공통 라우팅은 tenant-neutral 이어야
 * 하므로 host 가 bootstrap 시점에 컴포넌트를 주입한다.
 */

import type React from 'react';

export type TranslationModePageComponent = React.ComponentType;

let modePage: TranslationModePageComponent | null = null;

export function setTranslationModePageComponent(
  component: TranslationModePageComponent | null,
): void {
  modePage = component;
}

export function getTranslationModePageComponent(): TranslationModePageComponent | null {
  return modePage;
}
